import React from 'react'
import { FormattedMessage } from 'react-intl'
import { RESERVE_PARAMETERS_TYPES } from 'constants'

const nbsp = <span>&nbsp;</span>

export const DEFAULT_LAYOUT_PARAMETERS_DESCRIPTION = {
    [RESERVE_PARAMETERS_TYPES.CREW_ROLES_FACTOR]: (
        <FormattedMessage
            id='battle_reserve.default_layout.parameter_description.crew_roles_factor'
            defaultMessage='к основной специальности и умениям экипажа'
        />
    ),
    [RESERVE_PARAMETERS_TYPES.COMMON_AREA_RADIUS]: (
        <FormattedMessage
            id='battle_reserve.default_layout.parameter_description.common_area_radius'
            defaultMessage='м. радиус действия'
        />
    ),
    [RESERVE_PARAMETERS_TYPES.MAX_DAMAGE]: (
        <FormattedMessage
            id='battle_reserve.default_layout.parameter_description.max_damage'
            defaultMessage='ед. максимального урона для боёв на VI / VIII / X уровне техники'
        />
    ),
    [RESERVE_PARAMETERS_TYPES.AREA_RADIUS]: (
        <FormattedMessage
            id='battle_reserve.default_layout.parameter_description.area_radius'
            defaultMessage='м. радиус зоны поражения'
        />
    ),
    [RESERVE_PARAMETERS_TYPES.INSPIRATION_INDUSTRIAL_RESOURCE_BONUS]: (
        <FormattedMessage
            id='battle_reserve.default_layout.parameter_description.inspiration_industrial_resource_bonus'
            defaultMessage='к промресурсу при воодушевлении'
        />
    ),
    [RESERVE_PARAMETERS_TYPES.ARTILLERY_STRIKE_INDUSTRIAL_RESOURCE_BONUS]: (
        <FormattedMessage
            id='battle_reserve.default_layout.parameter_description.artillery_strike_industrial_resource_bonus'
            defaultMessage='к промресурсу при вызове артобстрела'
        />
    ),
}

export const RESERVES_PARAMETERS_DESCRIPTION = {
    ...DEFAULT_LAYOUT_PARAMETERS_DESCRIPTION,
    [RESERVE_PARAMETERS_TYPES.COMMON_AREA_RADIUS]: (
        <FormattedMessage
            id='battle_reserve.parameter_description.common_area_radius'
            defaultMessage='Радиус действия{nbsp}(м)'
            values={{
                nbsp,
            }}
        />
    ),
    [RESERVE_PARAMETERS_TYPES.CREW_ROLES_FACTOR]: (
        <FormattedMessage
            id='battle_reserve.parameter_description.crew_roles_factor'
            defaultMessage='к основной специальности и умениям экипажа'
        />
    ),
    [RESERVE_PARAMETERS_TYPES.DURATION]: (
        <FormattedMessage
            id='battle_reserve.parameter_description.duration'
            defaultMessage='Продолжительность{nbsp}(с)'
            values={{
                nbsp,
            }}
        />
    ),
    [RESERVE_PARAMETERS_TYPES.INACTIVATION_DELAY]: (
        <FormattedMessage
            id='battle_reserve.parameter_description.inactivation_delay'
            defaultMessage='Остаточный эффект{nbsp}(с)'
            values={{
                nbsp,
            }}
        />
    ),
    [RESERVE_PARAMETERS_TYPES.MAX_DAMAGE]: (
        <FormattedMessage
            id='battle_reserve.parameter_description.max_damage'
            defaultMessage='Максимальный урон для боёв на VI / VIII / X уровне техники{nbsp}(ед.)'
            values={{
                nbsp,
            }}
        />
    ),
    [RESERVE_PARAMETERS_TYPES.AREA_RADIUS]: (
        <FormattedMessage
            id='battle_reserve.parameter_description.area_radius'
            defaultMessage='Радиус зоны поражения{nbsp}(м)'
            values={{
                nbsp,
            }}
        />
    ),
    [RESERVE_PARAMETERS_TYPES.COMMON_DELAY]: (
        <FormattedMessage
            id='battle_reserve.parameter_description.common_delay'
            defaultMessage='Время развёртывания{nbsp}(с)'
            values={{
                nbsp,
            }}
        />
    ),
}



// WEBPACK FOOTER //
// ./components/ReserveBonus/components/BonusParametersDescription/translations.jsx